import initLoadIn from './utilities/load-in';
import initLazyVideo from './utilities/lazy-video';
import initScrollTo from './utilities/scroll-to';

const lazyVideoEls = document.querySelectorAll('video.js-lazy');

if (lazyVideoEls) {
    initLazyVideo(lazyVideoEls);
}

const loadInEls = document.querySelectorAll('.js-load-in');

if (loadInEls && loadInEls.length > 0) {
    initLoadIn(loadInEls);
}

const scrollToEls = document.querySelectorAll('.js-scroll-to');

if (document.body.dataset.page === 'home' && scrollToEls && scrollToEls.length > 0) {
    initScrollTo(scrollToEls);
}
